import ISale from "@/@types/health/sale";

export default class SalesEnum {
    static SALE_ALDRIC = {
        expert_id: 84,
        tel: '0743391775',
        image: 'ALDRIC_BELHADJ',
        name: 'Notre Expert',
        satisfied_clients: 1407,
        clientsReviews: 118,
        seniority: 3,
        reviews: [
            {
                provider: 'Avis Google',
                stars: 5,
                reviewerName: 'Rayane',
                date: 'Il y a 3 jours',
                comment: `Aldric B. est quelqu’un de très humain qui sera vous mettre à l’aise et prendra tout le 
                    temps nécessaire pour répondre à vos demandes et questions ! Un grand merci à vous pour votre 
                    professionnalisme !`,
            },
            {
                provider: 'Avis Google',
                stars: 5,
                reviewerName: 'Cathy',
                date: 'Il y a 7 jours',
                comment: `Je suis très satisfaite de l'accompagnement d'Aldric pour choisir ma mutuelle santé. 
                    Efficacité, rapidité, et contact très aimable. Ca fait du bien de parler à de "vraies" personnes et 
                    non des robots. Je recommande vivement!`,
            },
            {
                provider: 'Avis Google',
                stars: 5,
                reviewerName: 'Brahim',
                date: 'Il y a 20 jours',
                comment: `M.Aldric c'est juste le fleuron des conseillers !!! Vraiment répond toujours présent et 
                    vous conseille très bien en fonction de vos réelles besoins, toujours à l'écoute active et souriant 
                    (ça se sent au téléphone).`,
            },
        ],
    }

    static SALE_PIERRE = {
        expert_id: 129,
        tel: '0744099012',
        image: 'PIERRE_ROUILLE',
        name: 'Pierre R',
        satisfied_clients: 458,
        reviews: [
            {
                provider: 'Avis Vérifiés',
                reviewerName: 'Sarah',
                date: 'Il y a 1 semaine',
                stars: 5,
                comment: `Très contente de ma souscription. Mes besoins ont été pris en compte et mon conseiller m'a
                 proposé exactement ce que je cherchais. Il a répondu à toutes mes interrogations dans la journée.
                  Très disponible. Je redommande vivement. Encore merci Alban.`,
            },
            {
                provider: 'Avis Vérifiés',
                reviewerName: 'Philipe',
                date: 'Il y a 2 semaines',
                stars: 4,
                comment: `Un grand merci à Alban pour le temps qu'il a consacré à la mise en place de notre nouvelle
                 mutuelle. De bons conseils à suivre. Ne changez rien. Cordialement.`,
            },
            {
                provider: 'Avis Vérifiés',
                reviewerName: 'Valérie',
                date: 'Il y a 4 jours',
                stars: 5,
                comment: `Je cherche à revoir mes contrats. J'ai contacté Réassurez-moi car je suis déjà passée par
                 eux l'année dernière. Aujourd'hui, je cherche à revoir ma mutuelle pour l'adapter à ma situation
                  actuelle. Alban m'a très bien conseillée, est à l'écoute des besoins exprimés et m'a fait une
                   proposition très intéressante. Je recommande !`,
            },
        ],
    }

    static SALE_FLORA = {
        expert_id: 74,
        tel: '0743391777',
        image: 'default',
        name: 'Flora C',
        satisfied_clients: 458,
        reviews: [
            {
                provider: 'Avis Google',
                reviewerName: 'Raphaël',
                date: 'Il y a 3 jours',
                stars: 5,
                comment: `Très satisfait de la prestation de Pierre, une personne compétente et disponible.
                    Sa présentation claire et pertinente de la mutuelle Sérénité 2 d’Apicil nous a ainsi incité
                    à souscrire cette mutuelle`,
            },
            {
                provider: 'Avis Google',
                reviewerName: 'Joël',
                date: 'Il y a 1 semaine',
                stars: 5,
                comment: `Site clair. L'équipe répond aux mails sous 24h et accompagne. Efficace`,
            },
            {
                provider: 'Avis Google',
                reviewerName: 'Abel',
                date: 'Il y a 20 jours',
                stars: 5,
                comment: `Pierre a été très professionnel et nous a bien conseillé pour la souscription
                    de notre nouvelle mutuelle. Le suivi est top! Je recommande`,
            },
        ],
    }

    static SALE_HEALTH = {
        expert_id: 'EQUIPE_MS',
        tel: '0188469467',
        image: 'default',
        name: 'Équipe MS',
        satisfied_clients: 331,
        reviews: [
            {
                provider: 'Avis Vérifiés',
                reviewerName: 'Sarah',
                date: 'Il y a 1 semaine',
                stars: 5,
                comment: `Très contente de ma souscription. Mes besoins ont été pris en compte et mon conseiller m'a
                 proposé exactement ce que je cherchais. Il a répondu à toutes mes interrogations dans la journée.
                  Très disponible. Je redommande vivement. Encore merci Alban.`,
            },
            {
                provider: 'Avis Vérifiés',
                reviewerName: 'Philipe',
                date: 'Il y a 2 semaines',
                stars: 4,
                comment: `Un grand merci à Alban pour le temps qu'il a consacré à la mise en place de notre nouvelle
                 mutuelle. De bons conseils à suivre. Ne changez rien. Cordialement.`,
            },
            {
                provider: 'Avis Vérifiés',
                reviewerName: 'Valérie',
                date: 'Il y a 4 jours',
                stars: 5,
                comment: `Je cherche à revoir mes contrats. J'ai contacté Réassurez-moi car je suis déjà passée par
                 eux l'année dernière. Aujourd'hui, je cherche à revoir ma mutuelle pour l'adapter à ma situation
                  actuelle. Alban m'a très bien conseillée, est à l'écoute des besoins exprimés et m'a fait une
                   proposition très intéressante. Je recommande !`,
            },
        ],
    }

    static reviews: ISale[] = [
        this.SALE_ALDRIC,
        this.SALE_PIERRE,
        this.SALE_FLORA,
        this.SALE_HEALTH
    ]

    static ID_MAP_BY_MAIL: {[key: string]: ISale['expert_id']} = {
        "aldric@reassurez-moi.fr": this.SALE_ALDRIC.expert_id,
        'pierre.rouille@reassurez-moi.fr': this.SALE_PIERRE.expert_id,
        'flora@reassurez-moi.fr': this.SALE_FLORA.expert_id,
    }

    static ID_TO_SALE: Record<string, ISale> = {
        [this.SALE_ALDRIC.expert_id]: this.SALE_ALDRIC,
        [this.SALE_PIERRE.expert_id]: this.SALE_PIERRE,
        [this.SALE_HEALTH.expert_id]: this.SALE_HEALTH,
        [this.SALE_FLORA.expert_id]: this.SALE_FLORA,
    }
}
